<template>
  <nav class="nav">
    <div class="wrap nav-inner">
      <a class="logo" href="#top">
        <span class="logo-mark">微</span>
        <span class="logo-name">微米数字科技</span>
      </a>
      <div class="nav-links">
        <a href="#services">服务</a>
        <a href="#products">产品</a>
        <a href="#process">流程</a>
        <a href="#team">团队</a>
        <a href="#about">关于</a>
        <a class="nav-cta" href="#contact">联系我们</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'SiteHeader'
}
</script>

<style scoped>
.nav {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(250, 250, 249, 0.86);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--line);
}

.nav-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: var(--ink);
}

.logo-mark {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: var(--ink);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-name {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 30px;
}

.nav-links a {
  color: var(--ink-2);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.15s;
}

.nav-links a:hover {
  color: var(--ink);
}

.nav-links a.nav-cta {
  background: var(--ink);
  color: #fff;
  text-decoration: none;
  font-size: 13.5px;
  padding: 8px 18px;
  border-radius: 8px;
  transition: background 0.15s;
}

.nav-links a.nav-cta:hover {
  background: #2C2C34;
  color: #fff;
}

@media (max-width: 860px) {
  .nav-links a:not(.nav-cta) {
    display: none;
  }
}
</style>
